import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import { useEffect, useState } from "react";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import CustomAutocomplete from "../sredstva-prva-pomoc/CustomAutocomplete";
import DateSelect from "../../globalno-dodavanje/DateSelect";

const vrsteAllMock = [
  {
    id: "1",
    name: "Radna masina"
  },
  {
    id: "2",
    name: "Viljuskar"
  },
  {
    id: "3",
    name: "Putnicko"
  },
  {
    id: "4",
    name: "Dizalica"
  }
];
const tipoviAllMock = ["TS1", "TS2", "TS3"];
const vozaciAllMock = [
  {
    id: "1",
    name: "Pera Peric"
  },
  {
    id: "2",
    name: "Mika Mikic"
  },
  {
    id: "3",
    name: "Zika Zikic"
  }
];

const emptyData = {
  vrsta: { id: -1, name: "" },
  tip: "",
  regOznaka: "",
  istice: "",
  vozac: { id: -1, name: "" }
};

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  },
  select: {
    width: "25%",
    maxHeight: "340px"
  }
};

function DodavanjeSredstva({
  setIsDodavanje,
  setSredstva,
  editData,
  setEditData
}) {
  const [data, setData] = useState(emptyData);

  const [vrsteAll, setVrsteAll] = useState([]);
  const [tipoviAll, setTipoviAll] = useState([]);
  const [vozaciAll, setVozaciAll] = useState([]);

  const { dictionary } = useGlobalContext();

  useEffect(() => {
    setVrsteAll(vrsteAllMock);
  }, [vrsteAllMock]);

  useEffect(() => {
    setTipoviAll(tipoviAllMock);
  }, [tipoviAllMock]);

  useEffect(() => {
    setVozaciAll(vozaciAllMock);
  }, [vozaciAllMock]);

  useEffect(() => {
    if (editData) {
      setData(editData);
    }
  }, [editData]);

  const handleChange = (newValue, field) => {
    setData((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleClose = () => {
    setIsDodavanje(false);
    if (editData) setEditData(null);
  };

  const handleSacuvaj = () => {
    console.log(data);

    if (editData) {
      setSredstva((prev) =>
        prev.map((sr) => (sr.id === editData.id ? data : sr))
      );
    } else {
      setSredstva((prev) => [
        ...prev,
        {
          ...data,
          id: prev.length,
          redniBroj: prev.length,
          status: "green"
        }
      ]);
    }

    handleClose();
  };

  const handleIzbrisi = () => {
    setSredstva((prev) => prev.filter((sr) => sr.id !== editData.id));
    handleClose();
  };

  const isDisabledSacuvaj =
    !data.vrsta.name ||
    !data.tip ||
    !data.regOznaka ||
    !data.vozac.name ||
    !data.istice ||
    data.istice.includes("undefined");

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "flex-end"
        }}
      >
        <CustomSelect
          label={dictionary["vrsta"]}
          allValues={vrsteAll}
          selectedValue={data.vrsta}
          onSelectChange={(newValue) => handleChange(newValue, "vrsta")}
          readOnly={!!editData}
        />
        <CustomAutocomplete
          label={dictionary["tip"]}
          allValues={tipoviAll}
          selectedValue={data.tip}
          onSelectChange={(newValue) => handleChange(newValue, "tip")}
        />
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["registracija"]}
          </div>
          <input
            value={data.regOznaka}
            onChange={(e) => handleChange(e.target.value, "regOznaka")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>

        <DateSelect
          label={dictionary["istice"]}
          selectedValue={data.istice}
          onSelectChange={(newValue) => handleChange(newValue, "istice")}
        />

        <CustomSelect
          label={dictionary["vozac"]}
          allValues={vozaciAll}
          selectedValue={data.vozac}
          onSelectChange={(newValue) => handleChange(newValue, "vozac")}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "15px"
        }}
      >
        <div onClick={handleClose}>
          <Button activation={true} style={styles.button}>
            {dictionary["odustani"]}
          </Button>
        </div>
        {editData && (
          <div onClick={handleIzbrisi}>
            <Button activation={true} style={styles.button}>
              {dictionary["izbrisi"]}
            </Button>
          </div>
        )}
        <div
          onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
          style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button activation={true} style={styles.button}>
            {editData ? dictionary["izmeni"] : dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DodavanjeSredstva;
